import DenounceStatusService from '../../services/DenounceStatusService';

import { Button } from '@mui/material';
import SimpleMap from '../SimpleMap/SimpleMap';

import settings from '../../settings/settings';

import './MapVisualizer.scss'

function MapVisualizer({ className, heatmapData, handleClickHideMap, workingAreas, workingArea, 
  vectorFocus, vectorFoci, userLocation, showPins, showWorkingAreas, showHeatmap, showUserLocation }) {

  const classNames = `map-visualizer ${className || ''}`;
  const denounceStatusService = new DenounceStatusService();

  if (workingAreas && workingArea && vectorFoci) {
    const workingAreasPolygons = workingAreas.map(workingArea => {
      return {
        ...workingArea.geo_location,
        seriousnessScoreNumOpenedVectors: -1
      };
    });
    const parsedVectorFoci = vectorFoci.map((vectorFocus) => {
      const infoURL = `${settings.getBasePath()}#/vector-focus-details/${vectorFocus.id}`;
      vectorFocus.geo_location.info = {
        id: vectorFocus?.id,
        infoURL: infoURL,
        denounceStatus: {
          name: vectorFocus?.denounce_status?.name
        },
        description: vectorFocus?.description,
        seriousnessScore: vectorFocus?.seriousness_score
      };
      return vectorFocus.geo_location;
    });

    return (
      <div className={classNames}>
        <SimpleMap
          mapTypeId="terrain"
          readOnly={true}
          isEditEnabled={false}
          showPins={showPins}
          showWorkingAreas={showWorkingAreas}
          showHeatmap={showHeatmap}
          showUserLocation={showUserLocation}
          userLocation={userLocation}
          zoom={settings.DEFAULT_MAP_ZOOM_CLOSE}
          center={workingArea.geo_location || settings.DEFAULT_MAP_LOCATION}
          geoLocationToLoad={workingArea.geo_location}
          focusedGeoLocation={workingArea.geo_location}
          pins={parsedVectorFoci}
          pinsFilters={[
            denounceStatusService.DENOUNCE_STATUS.OPENED.name,
            denounceStatusService.DENOUNCE_STATUS.IN_PROGRESS.name,
            denounceStatusService.DENOUNCE_STATUS.CLOSED.name
          ]}
          workingAreas={workingAreasPolygons}
          workingAreasPolygons={workingAreasPolygons}
          onPolygonClicked={null}
          heatmapData={heatmapData}
        />
        {handleClickHideMap && <Button onClick={handleClickHideMap}>Fechar o mapa</Button>}
      </div>
    )
  }

  if (workingArea) {
    workingArea.geo_location.seriousnessScoreNumOpenedVectors = 0.1;

    return (
      <div className={classNames}>
        <SimpleMap
          mapTypeId="terrain"
          readOnly={true}
          isEditEnabled={false}
          showWorkingAreas={true}
          showUserLocation={showUserLocation}
          userLocation={userLocation}
          zoom={settings.DEFAULT_MAP_ZOOM_CLOSE}
          center={workingArea.geo_location || settings.DEFAULT_MAP_LOCATION}
          geoLocationToLoad={workingArea.geo_location}
          focusedGeoLocation={workingArea.geo_location}
          workingAreas={[workingArea.geo_location]}
          workingAreasPolygons={[workingArea.geo_location]}
          onPolygonClicked={null}
        />
        {handleClickHideMap && <Button onClick={handleClickHideMap}>Fechar o mapa</Button>}
      </div>
    )
  }

  if (vectorFocus) {
    vectorFocus.geo_location.info = {
      denounceStatus: {
        name: vectorFocus?.denounce_status?.name
      },
      description: vectorFocus?.description,
      seriousnessScore: vectorFocus?.seriousness_score
    };

    return (
      <div className={classNames}>
        <SimpleMap
          mapTypeId="terrain"
          readOnly={true}
          isEditEnabled={false}
          showPins={true}
          showUserLocation={showUserLocation}
          userLocation={userLocation}
          zoom={settings.DEFAULT_MAP_ZOOM_CLOSE}
          center={vectorFocus.geo_location || settings.DEFAULT_MAP_LOCATION}
          pins={[vectorFocus.geo_location]}
          pinsFilters={[
            denounceStatusService.DENOUNCE_STATUS.OPENED.name,
            denounceStatusService.DENOUNCE_STATUS.IN_PROGRESS.name,
            denounceStatusService.DENOUNCE_STATUS.CLOSED.name
          ]}
          onPinClicked={null}
        />
        {handleClickHideMap && <Button onClick={handleClickHideMap}>Fechar o mapa</Button>}
      </div>
    )
  }

  return <></>;
}

export default MapVisualizer;
